import { type DealTrackingLimitedPartnerBreakdown } from "@vega-api/generated/types/dealTrackingLimitedPartnerBreakdown";

import { TrackProcessTable } from "../components/TrackProcessTable/TrackProcessTable";

type ProcessViewProps = {
  dealId: string;
  limitedPartnerBreakdown: DealTrackingLimitedPartnerBreakdown[];
  isLoading: boolean;
};

export const ProcessView = ({
  dealId,
  limitedPartnerBreakdown,
  isLoading,
}: ProcessViewProps) => (
  <div className="space-y-4 pb-52">
    <TrackProcessTable
      data={limitedPartnerBreakdown}
      dealId={dealId}
      isLoading={isLoading}
    />
  </div>
);
